import React, { memo, useRef } from 'react';
import { useTabPanel } from 'react-aria';

import { tabMenuCls } from '../utils';

import { TabPanelProps } from './types';

/**
 * Компонент для отображения контента выбранной вкладки
 */
export const TabPanel = memo<TabPanelProps>(function TabPanel({ state, className, children, ...props }) {
    const ref = useRef<HTMLDivElement>(null);
    const { tabPanelProps } = useTabPanel(props, state, ref);

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- selectedItem.props оставляем тип any
    const content = state.selectedItem?.props.content;

    if (!content) {
        return null;
    }

    return (
        <div {...tabPanelProps} ref={ref} className={tabMenuCls('tabPanel', [className])}>
            {content}
        </div>
    );
});
